import { jsx as _jsx } from "react/jsx-runtime";

function SvgCross() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.963 6.422c.39-.391.39-1.025 0-1.416a.997.997 0 00-1.413 0L12 10.57 6.45 5.006a.997.997 0 00-1.414 0 1.003 1.003 0 000 1.416l5.551 5.562-5.581 5.594c-.39.39-.39 1.024 0 1.415a.997.997 0 001.413 0l5.58-5.593 5.582 5.593a.997.997 0 001.412 0c.39-.39.39-1.025 0-1.415l-5.58-5.594 5.55-5.562z"
    }, void 0)
  }), void 0);
}

export default SvgCross;